import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import '../../../Autoshipment/AutoshipmentCircle/AutoshipmentCircle.js';
import '../../../Autoshipment/AutoshipmentLogoLockup/AutoshipmentLogoLockup.js';
import { AutoshipmentLogoMark } from '../../../Autoshipment/AutoshipmentLogoMark/AutoshipmentLogoMark.js';
import style from '../ProductPrice.module.scss.js';

const AutoshipmentPriceDetails = (props) => {
    const { amount, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hideMainPrice, label, ...otherProps } = props;
    return (jsxs("div", { className: classNames(style['z-product-price__autoshipment'], {
            ['z-product-price__autoshipment--standalone']: !!hideMainPrice,
        }), ...otherProps, children: [jsx(AutoshipmentLogoMark, { realm: "zooplus", alt: label || '', verticalAlign: "bottom", className: classNames(style['z-product-price__autoshipment__logo'], style['z-product-price__autoshipment__logo--zooplus']) }), jsx(AutoshipmentLogoMark, { realm: "bitiba", alt: label || '', verticalAlign: "bottom", className: classNames(style['z-product-price__autoshipment__logo'], style['z-product-price__autoshipment__logo--bitiba']) }), ' ', hideMainPrice ? jsx("strong", { children: amount }) : amount] }));
};
AutoshipmentPriceDetails.displayName = 'AutoshipmentPriceDetails';

export { AutoshipmentPriceDetails };
//# sourceMappingURL=AutoshipmentPriceDetails.js.map
